import { createAction } from 'redux-actions';

export const SET_PRODUCT_ID = 'SET_PRODUCT_ID';

const setProductId = createAction(SET_PRODUCT_ID);

export default {
    setProductId
};



// WEBPACK FOOTER //
// ./containers/app/product-id/product-id-actions.js